var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { BsFillVolumeMuteFill } from 'react-icons/bs';
import styled from 'styled-components';
export var MuteIcon = styled(BsFillVolumeMuteFill)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: rgb(255, 255, 255);\n  position: absolute;\n  top: 5px;\n  right: 49%;\n"], ["\n  color: rgb(255, 255, 255);\n  position: absolute;\n  top: 5px;\n  right: 49%;\n"])));
var templateObject_1;
